import React, { useEffect } from "react";

import analytics from "src/shared/contact-boxes/experts/utilities/analytics";
import useFeatureState from "src/shared/contact-boxes/experts/utilities/hooks/useFeatureState";
import useReducerActions from "src/shared/contact-boxes/experts/utilities/useReducerActions";

import * as S from "./styled";

const RestrictedSaleModal = () => {
  const {
    dispatchSetContactFormType,
    dispatchSetWhatYouShouldKnowModal
  } = useReducerActions();
  const { contactFormType, expertsApiUuid, isModalOpen } = useFeatureState();
  const onRequestClose = () =>
    dispatchSetWhatYouShouldKnowModal({
      contactFormType: null,
      isModalOpen: false
    });

  useEffect(() => {
    if (isModalOpen) {
      analytics({
        action: "impressions_for_restricted_sales_info",
        isHdp: true,
        label: `uuid=${expertsApiUuid}|from=${
          contactFormType ? "contact" : "link"
        }`,
        unique: true
      });
    }
  }, [isModalOpen]);

  return (
    <S.Modal
      data-qa="restricted-sale-modal"
      isOpen={Boolean(isModalOpen)}
      onRequestClose={onRequestClose}
    >
      <S.RestrictedSaleModalTitle>
        <S.Title>
          What You Should Know About Restricted Sales, Like HDFCs
        </S.Title>
      </S.RestrictedSaleModalTitle>
      <S.ModalBody>
        <S.SubTitle>Buyer Qualifications</S.SubTitle>
        <S.Text>
          Qualified buyers earn below specific income limits. NYC area median
          income (AMI) defines these limits, which differ by family size. For
          restricted sales, like HDFC co-ops, often income limits are below 165%
          of AMI and vary by building.
        </S.Text>
        <S.SubTitle>Purchase Considerations</S.SubTitle>
        <S.Text>
          Be sure to confirm financing requirements. Restricted sales can
          require large down payments and cash only offers. Plus, they can limit
          co-purchasing and subletting.
        </S.Text>
        <S.ButtonContainer>
          {contactFormType ? (
            <S.Button
              onClick={() => {
                dispatchSetContactFormType(contactFormType);
              }}
            >
              Got it, continue
            </S.Button>
          ) : (
            <S.Button onClick={onRequestClose}>Got it</S.Button>
          )}
        </S.ButtonContainer>
        <S.Link
          href="https://streeteasy.com/blog/what-is-an-hdfc-co-op/"
          onClick={() => {
            analytics({
              action: "click_to_restricted_sales_blog",
              isHdp: true,
              label: `uuid=${expertsApiUuid}|from=${
                contactFormType ? "contact" : "link"
              }`
            });
          }}
          target="_blank"
        >
          learn more about restricted sales on our blog
        </S.Link>
      </S.ModalBody>
    </S.Modal>
  );
};

export default RestrictedSaleModal;
